import * as React from 'react';
import loadScript from '../../lib/loadScript';

declare global {
  interface Window {
    ___gcfg?: {
      parsetags?: 'explicit'
    }
    gapi?: {
      savetodrive: {
        render: (el: HTMLElement, props: { src: string, filename: string, sitename: string }) => void
      }
    }
  }
}

if (typeof window !== 'undefined') {
  window.___gcfg = {
    // avoid the script from kicking in automatically
    parsetags: 'explicit'
  };
}

interface SaveToDriveButtonProps {
  src: string
  filename: string
}

export default function SaveToDriveButton ({ src, filename }: SaveToDriveButtonProps) {
  const btnRef = React.useRef<HTMLDivElement>(null);

  React.useEffect(() => {
    loadScript('https://apis.google.com/js/platform.js')
      .then(() => {
        if (!btnRef.current || !window.gapi) {
          return;
        }
        window.gapi.savetodrive.render(btnRef.current, {
          src,
          filename,
          sitename: 'DataBravo'
        });
      });
  }, [src, filename]);

  return (
    <div ref={btnRef} />
  );
}
